import { Sort } from '@angular/material/sort';
import { Posting } from '../models/posting.model';

export class AddAllPostings {
    static readonly type = '[AllPostings] AddAllPostings';

    constructor(public payload: Posting[]) {}
}

export class SetAllPostings {
    static readonly type = '[AllPostings] SetAllPostings';

    constructor(public payload: Posting[]) {}
}

export class UnsetAllPostings {
    static readonly type = '[AllPostings] UnsetAllPostings';
}

export class FetchAllPostings {
    static readonly type = '[AllPostings] FetchAllPostings';

    constructor(
        public payload?: {
            pageSize: number;
            pageNumber: number;
            sortBy: string;
            sortOrder: string;
            search: string;
            postingTypeId?: number;
            languageId?: string;
            contentTypeId?: number;
            onlyValid?: boolean;
        }
    ) {}
}

export class FetchAllPostingsSuccess {
    static readonly type = '[AllPostings] FetchAllPostingsSuccess';

    constructor(public payload: Posting[]) {}
}

export class FetchAllPostingsFailure {
    static readonly type = '[AllPostings] FetchAllPostingsFailure';
}

export class ToggleSelectedPosting {
    static readonly type = '[AllPostings] ToggleSelectedPosting';

    constructor(public payload: string) {}
}

export class SelectFilteredPostings {
    static readonly type = '[AllPostings] SelectFilteredPostings';
}

export class DeselectSelectedPostings {
    static readonly type = '[AllPostings] DeselectSelectedPostings';
}

export class SearchAllPostings {
    static readonly type = '[AllPostings] SearchAllPostings';

    constructor(public payload: string) {}
}

export class SortAllPostings {
    static readonly type = '[AllPostings] SetAllPostingsSort';

    constructor(public payload: Sort) {}
}

export class SortOrderAllPostings {
    static readonly type = '[AllPostings] SortOrder';

    constructor(public payload: string) {}
}

export class SortByAllPostings {
    static readonly type = '[AllPostings] SortBy';

    constructor(public payload: string) {}
}

export class SortLanguageAllPostings {
    static readonly type = '[AllPostings] SortLanguage';

    constructor(public payload: string) {}
}
